
export const ResizeIcon = () => {
    return (
			<svg
					xmlns="http://www.w3.org/2000/svg"
					width="24"
					height="24"
					fill="none"
					viewBox="0 0 24 24"
			>
			<path
					stroke="#FFF"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="1.5"
					d="m9 14 3 3 3-3m0-4-3-3-3 3"
			></path>
			</svg>
    )
}